import request from '@/utils/request'

export const mallApi = {
    // 获取商品列表
    getProducts() {
        return request({
            url: '/api/v1/mall/products/',
            method: 'get'
        })
    },

    // 创建订单
    createOrder(data) {
        return request({
            url: '/api/v1/mall/orders/',
            method: 'post',
            data
        })
    },

    getOrders(params) {
        return request({
            url: '/api/v1/mall/orders/',
            method: 'get',
            skipApiCache: params?.skipApiCache === true,
            params: {
                page: params.page || 1,
                page_size: params.pageSize || 10,
                status: params.status === 'all' ? '' : params.status,
                ordering: params.ordering || '-create_time',
                start_time: params.startTime,
                end_time: params.endTime,
                order_number: params.orderNumber
            }
        })
    },

    // 更新订单地址
    updateOrderAddress(orderId, addressData) {
        return request({
            url: `/api/v1/mall/orders/${orderId}/update-address/`,
            method: 'PATCH',
            data: addressData
        })
    },

    // 更新订单备注（银行下款选中银行等）
    updateOrderRemark(orderId, data) {
        return request({
            url: `/api/v1/mall/orders/${orderId}/update-remark/`,
            method: 'patch',
            data
        })
    }
}
